import { getCountry, getProvince, getProduct } from '@/services/api';
import moment from 'moment';
import dayjs from 'dayjs';
import { getToDay } from '@/utils/date';

const dateRange = getToDay();

const searchData = {
  queryDate: moment(dateRange[0]).add(-1, 'days'),
  queryType: '1',
};

export default {
  namespace: 'NotPressRouteTransportGoodsBoard',

  state: {
    // 查询条件
    searchFrom: { ...searchData },
    // 折线图
    productList: [],
    // 饼图 数据
    productPieList: [],
    // 省区 数据
    provinceList: [],
    xAxisList: [],
    y1AxisList: [],
    y2AxisList: [],
  },

  effects: {
    //全国--折线图
    *getCountry(_, { call, put, select }) {
      const params = yield select(({ NotPressRouteTransportGoodsBoard }) => ({
        queryDate: moment(NotPressRouteTransportGoodsBoard.searchFrom.queryDate).format(
          'YYYY-MM-DD HH:mm:ss',
        ),
        queryType: NotPressRouteTransportGoodsBoard.searchFrom.queryType,
      }));
      const data = yield call(getCountry, params);
      const allData = (data.data || []).map(itm => ({
        // dateTime:moment(itm.dateTime).valueOf(),
        dateTime: itm.dateTime,
        abnormalTicket: parseInt(itm.abnormalTicket),
        percentage: Number(itm.percentage),
      }));
      const xAxis = allData.map(itm => itm.dateTime);
      const xAxisList = xAxis.sort((a: string | number | Date, b: string | number | Date) => {
        return new Date(a).valueOf() - new Date(b).valueOf();
      });
      const y1AxisList = (allData || []).map(itm => itm.abnormalTicket);
      const y2AxisList = (allData || []).map(itm => itm.percentage);
      if (data && data.code === 1) {
        yield put({
          type: 'update',
          payload: {
            productList: allData || [],
            xAxisList: xAxisList || [],
            y1AxisList: y1AxisList || [],
            y2AxisList: y2AxisList || [],
          },
        });
      }
    },

    //省区--列表
    *getProvince(_, { call, put, select }) {
      const params = yield select(({ NotPressRouteTransportGoodsBoard }) => ({
        queryDate: moment(NotPressRouteTransportGoodsBoard.searchFrom.queryDate).format(
          'YYYY-MM-DD HH:mm:ss',
        ),
        queryType: NotPressRouteTransportGoodsBoard.searchFrom.queryType,
      }));
      const data = yield call(getProvince, params);
      // console.log('getProvince----省区列表数据', data.data);
      const getNum = val =>
        Number(
          dayjs(val.dateTime)
            .format('YYYY-MM-DD')
            .split('-')[2],
        );

      if (data && data.code === 1) {
        yield put({
          type: 'update',
          payload: {
            provinceList: (data.data || []).map((it, i) => ({
              ...it,
              id: i,
              dataByDay: it.dataByDay.sort((a, b) => getNum(a) - getNum(b)),
            })),
          },
        });
      }
    },

    //产品--饼状图
    *getProduct(_, { call, put, select }) {
      const params = yield select(({ NotPressRouteTransportGoodsBoard }) => ({
        queryDate: moment(NotPressRouteTransportGoodsBoard.searchFrom.queryDate).format(
          'YYYY-MM-DD HH:mm:ss',
        ),
        queryType: NotPressRouteTransportGoodsBoard.searchFrom.queryType,
      }));
      const data = yield call(getProduct, params);
      const dataList = (data.data || []).map(itm => ({
        name: itm.productType,
        value: itm.abnormalTicket,
      }));
      if (data && data.code === 1) {
        yield put({
          type: 'update',
          payload: {
            productPieList: dataList || [],
          },
        });
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
